import { useTranslation } from "react-i18next"
import img404 from "./img404.png"

export default function NotFound(props) {
  const [t] = useTranslation()

  return (
  <div><h1>{t("Page not found")}</h1><img src={img404} width="200" alt="" /></div>
  )
}